import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  const styles = {
    overlay: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'rgba(26, 26, 46, 0.98)',
      padding: '20px',
      zIndex: 9999,
      boxShadow: '0 -4px 20px rgba(0,0,0,0.2)'
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '20px'
    },
    text: {
      flex: '1 1 400px',
      color: '#fff',
      fontSize: '0.95rem',
      lineHeight: 1.6
    },
    link: {
      color: '#6db3f2',
      textDecoration: 'underline'
    },
    buttons: {
      display: 'flex',
      gap: '12px',
      flexWrap: 'wrap'
    },
    acceptButton: {
      padding: '12px 30px',
      background: '#2055df',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '0.95rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'background 0.3s'
    },
    declineButton: {
      padding: '12px 30px',
      background: 'transparent',
      color: '#fff',
      border: '2px solid rgba(255,255,255,0.3)',
      borderRadius: '8px',
      fontSize: '0.95rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s'
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        <p style={styles.text}>
          🍪 We use cookies to enhance your experience on Rx.ChatWithDr.com. By continuing to use 
          our site, you consent to our use of cookies for analytics and personalization. 
          <a href="/privacy" style={styles.link}> Learn more in our Privacy Policy</a>.
        </p>
        <div style={styles.buttons}>
          <button 
            onClick={handleAccept} 
            style={styles.acceptButton}
            onMouseOver={(e) => e.target.style.background = '#1844b8'}
            onMouseOut={(e) => e.target.style.background = '#2055df'}
          >
            Accept Cookies
          </button>
          <button 
            onClick={handleDecline} 
            style={styles.declineButton}
            onMouseOver={(e) => {
              e.target.style.background = 'rgba(255,255,255,0.1)';
              e.target.style.borderColor = 'rgba(255,255,255,0.5)';
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.borderColor = 'rgba(255,255,255,0.3)';
            }}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
